export enum IconAnimations {
    Rotate = 'Rotate',
}

export type IconType = string | { id: string; spritePath: string } | null

export interface IBaseIconProps {
    icon: IconType;
    fill?: string;
    animation?: IconAnimations
    className?: string;
    alt?: string;
}

export type SvgIconProps = IBaseIconProps & React.SVGProps<SVGSVGElement>;
export type ImgIconProps = IBaseIconProps & React.ImgHTMLAttributes<HTMLImageElement>;

export type IconProps = SvgIconProps | ImgIconProps;

